export type SortDirection = 'asc' | 'desc'

export interface SortState {
  field: string
  direction: SortDirection
}

export function parseSort(sort: string | null | undefined): SortState | null {
  const [field, direction] = (sort ?? '').split(':')
  const trimmed = field?.trim() ?? ''
  if (trimmed === '') return null
  return { field: trimmed, direction: direction?.trim() === 'asc' ? 'asc' : 'desc' }
}

export function serializeSort({ field, direction }: SortState): string {
  return `${field}:${direction}`
}

export function toggleSort(sort: string | null | undefined, field: string, fallback: SortDirection = 'desc'): string {
  const current = parseSort(sort)
  const flipped: SortDirection = current?.direction === 'asc' ? 'desc' : 'asc'
  return serializeSort({ field, direction: current?.field === field ? flipped : fallback })
}

export function parseList(raw: string | null | undefined): string[] {
  if (!raw) return []
  return raw
    .split(',')
    .map(item => item.trim())
    .filter(Boolean)
}

export function serializeList(values: string[]): string {
  return values
    .map(item => item.trim())
    .filter(Boolean)
    .join(',')
}

export interface QueryFilter {
  field: string
  values: string[]
  operator?: 'in' | 'eq' | 'between'
}

const clauseOf = ({ field, values, operator }: QueryFilter): string => {
  if (operator === 'eq') return `${field}=${values[0]}`
  if (operator === 'between') return `${field}><[${values[0]},${values[1]}]`
  return `${field}@${values.join(',')}`
}

export function buildQuery(filters: QueryFilter[]): string | undefined {
  const clauses = filters.filter(filter => (filter.operator === 'between' ? filter.values.length === 2 : filter.values.length > 0)).map(clauseOf)
  return clauses.length > 0 ? clauses.join(';') : undefined
}
